import { normalizeStatusList } from './../shared/utils';

export const UPJobQueryParams = ({ offset, statusList }) => ({
  offset,
  ...normalizeStatusList(statusList),
});
